import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss']
})
export class RecipeComponent implements OnInit {
  recipes: any[] = [];
  private fullRecipeList: any[] = [];
  loading: boolean = false;

  selectedBrand: number | null = null;
  selectedMeal: number | null = null;

  brandList: any[] = [];
  mealTimes: any[] = [];

  constructor(
    private api: SharedService,
    private router: Router
  ) { }


  async ngOnInit(): Promise<void> {
    this.loadProducts();
    const brandRes: any = await this.api.getList(API_MODULES.BRAND);
    this.brandList = Array.isArray(brandRes?.data) ? brandRes.data : [];
    const mealRes: any = await this.api.getList(API_MODULES.MEALTIME);
    this.mealTimes = Array.isArray(mealRes?.data) ? mealRes.data : [];
  }

  filterRecipes() {
    let filtered = this.fullRecipeList;

    if (this.selectedBrand != null) {
      filtered = filtered.filter(r =>
        r.brand?.some((b: any) => b.id == this.selectedBrand)
      );
    }

    if (this.selectedMeal != null) {
      filtered = filtered.filter(r => r.mealtime?.id == this.selectedMeal);
    }

    this.recipes = [...filtered];
  }

  async loadProducts(): Promise<void> {
    try {
      this.loading = true;
      const res: any = await this.api.getList(API_MODULES.RECIPE);
      if (res?.status === 'success' && res?.data) {
        this.fullRecipeList = res.data;
        this.recipes = [...this.fullRecipeList];
      }
    } catch (error) {
      console.error('Error loading recipes:', error);
    } finally {
      this.loading = false;
    }
  }

  getImg(path: string): string {
    if (!path) {
      return 'assets/no-image.png';
    }
    // If path already starts with http/https, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // Otherwise, append to base URL
    return this.api.imageBase + path;
  }

  viewRecipe(slugs: string): void {
    this.router.navigate(['/recipe-details', slugs]);
  }
}
